interface TitleProps {
  text: string
}

export default function Title({ text }: TitleProps) {
  return (
    <h1 className="text-3xl leading-14 font-bold text-white md:text-4xl">
      {text}
    </h1>
  )
}
